import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

export interface AddUserPayload {
  first_name: string;
  last_name: string;
  email: string;
  employee_id?: string;
  job_title: string;
  azure_id?: string;
  super_user: boolean;
  is_active: boolean;
}

@Component({
  selector: 'app-add-user-dialog',
  templateUrl: './add-user-dialog.component.html',
  styleUrl: './add-user-dialog.component.scss'
})
export class AddUserDialogComponent {
  private readonly emailPattern = /@.{1,}\.com$/i;
  showErrors = false;
  formData: AddUserPayload = {
    first_name: '',
    last_name: '',
    email: '',
    employee_id: '',
    job_title: '',
    azure_id: 'pending',
    super_user: false,
    is_active: true
  };

  constructor(private dialogRef: MatDialogRef<AddUserDialogComponent>) {}

  isEmailInvalid(): boolean {
    return !this.emailPattern.test(this.formData.email.trim());
  }

  isFormInvalid(): boolean {
    return !this.formData.first_name ||
      this.formData.first_name.trim().length < 2 ||
      !this.formData.last_name ||
      this.formData.last_name.trim().length < 2 ||
      !this.formData.email ||
      this.isEmailInvalid() ||
      !this.formData.azure_id ||
      this.formData.azure_id.trim().length === 0;
  }

  getValidationMessage(): string | null {
    if (!this.formData.first_name) {
      return 'First name must be filled out.';
    }
    if (this.formData.first_name.trim().length < 2) {
      return 'First name must be at least 2 characters.';
    }
    if (!this.formData.last_name) {
      return 'Last name must be filled out.';
    }
    if (this.formData.last_name.trim().length < 2) {
      return 'Last name must be at least 2 characters.';
    }
    if (!this.formData.email) {
      return 'Email must be filled out.';
    }
    if (this.isEmailInvalid()) {
      return 'Email must contain an @ followed by at least one character and end with .com.';
    }
    if (!this.formData.employee_id || this.formData.employee_id.trim().length === 0) {
      return 'Employee ID must be filled out.';
    }
    return null;
  }

  submit(): void {
    this.showErrors = true;
    if (this.isFormInvalid()) {
      return;
    }
    this.formData.job_title = 'TBD';
    this.formData.is_active = true;
    this.formData.employee_id = this.formData.employee_id?.trim();
    this.formData.azure_id = 'pending';
    this.dialogRef.close(this.formData);
  }

  cancel(): void {
    this.dialogRef.close();
  }
}
